class CustomAlert extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            topOffset: 0,
            leftOffset: 0,
        };
    }

    componentDidMount()
    {

        this.setState({
            topOffset: (window.innerHeight / 2) - (this.popup.clientHeight / 2),
            leftOffset: (window.innerWidth / 2) - (this.popup.clientWidth / 2),
        });
    }

    onSubmit(event)
    {
        if(_.isFunction(this.props.onSubmit)) this.props.onSubmit();
    }

    onClose(event)
    {
        if(_.isFunction(this.props.onSubmit) && this.props.submitOnClose) this.props.onSubmit();
        if(_.isFunction(this.props.onClose)) this.props.onClose();
    }

    render()
    {
        let buttons = [];
        _.each(this.props.buttons, (text, type) => {
            if(type === 'ok'){
                buttons.push(<button className="customAlertButtonOk" onClick={this.onSubmit.bind(this)} key={'button-' + text}>{text}</button>);
            }
            if(type === 'cancel'){
                buttons.push(<button className="customAlertButtonOk" onClick={this.onClose.bind(this)} key={'button-' + text}>{text}</button>);
            }
        });

        return (
            <div className="customAlert" style={{display: 'block', top: this.state.topOffset, left: this.state.leftOffset}} ref={(el) => {this.popup = el}}>
                <div className="customAlertInner">
                    <div className="customAlertTitle">
                        {this.props.title && <span>{this.props.title}</span>}
                        {this.props.closeButton && <a className="closeAlert" href="#" onClick={this.onClose.bind(this)}/>}
                    </div>
                    <div className="customAlertMsg">
                        {this.props.children || this.props.body}
                    </div>
                    {this.props.error &&
                    <div className="customAlertError">
                        {this.props.error}
                    </div>
                    }
                    <div className="customAlertButtons center">
                        {buttons}
                    </div>
                </div>
            </div>
        );
    }
}
CustomAlert.defaultProps = {
    title: null,
    closeButton: true,
    submitOnClose: false,
    buttons: {
        ok: 'OK',
    },
};
CustomAlert.displayName = 'CustomAlert';


class CategorySummary extends React.Component
{
    constructor(props)
    {
        super(props);

        let totalRaised = 0;
        let totalDonors = 0;
        let totalParticipants = 0;

        _.each(props.campaigns, campaign => {
            if(campaign.AdvocacyCategory.incremental){
                totalParticipants += campaign.AdvocacyCampaign.participants;
            }else{
                totalDonors += campaign.AdvocacyCampaign.participants;
                totalRaised += campaign.AdvocacyCampaign.raised;
            }
        });

        this.state = {
            loading: false,
            totalRaised: totalRaised,
            totalDonors: totalDonors,
            totalParticipants: totalParticipants,
            fundraisingCampaignsCount: _.size(_.filter(props.campaigns, campaign => campaign.AdvocacyCategory.incremental === false)),
            incrementalCampaignsCount: _.size(_.filter(props.campaigns, campaign => campaign.AdvocacyCategory.incremental === true)),
            showDetails: false,
            details: [],
            message: {
                title: false,
                body: false,
                buttons: {
                    ok: __d('advocacy','OK')
                },
                closeButton: false,
                submitOnClose: false,
            }
        };
    }

    clearMessage()
    {
        this.setState({
            message: {
                title: false,
                body: false,
                buttons: {
                    ok: __d('advocacy','OK')
                },
                closeButton: false,
                submitOnClose: false,
            }
        });
    }

    closeDetails()
    {
        this.setState({
            showDetails: false,
            details: [],
        });
    }

    groupRecords(records)
    {
        let groupedRecords = {};

        _.each(records, record => {
            let campaignId = record.AdvocacyCampaign.id;
            if(_.isNil(groupedRecords[campaignId])){
                groupedRecords[campaignId] = {
                    campaign: record.AdvocacyCampaign,
                    category: record.AdvocacyCategory,
                    items: [],
                };
            }
            groupedRecords[campaignId]['items'].push({
                goal: record.AdvocacyCampaignGoal,
                person: record.Person,
            });
        });

        return groupedRecords;
    }

    getDetails(type, ids)
    {
        this.setState({
            loading: true,
        });

        axios({
            method: 'get',
            url: SS.route('Advocacy', 'AdvocacyModules', 'categoryCampaignDetails', null),
            params: {
                type: type,
                ids: ids,
            }
        })
            .then(response => {
                this.setState({
                    showDetails: true,
                    details: this.groupRecords(response.data.records),
                    loading: false,
                });
            })
            .catch((error) => {
                let errorMessage;
                if (error.response) {
                    let data = error.response.data;
                    errorMessage = error.response.data.message;
                }else {
                    errorMessage = error.message;
                }
                this.setState({
                    message: {
                        title: __d('advocacy','Error'),
                        body: errorMessage,
                        buttons: {
                            ok: __d('advocacy','OK')
                        },
                        closeButton: false,
                        submitOnClose: true,
                        onSubmit: this.clearMessage.bind(this)
                    },
                    loading: false,
                });
            })
            .then(() => {

            });
    }

    render()
    {
        let loadingMask = null;
        if(this.state.loading){
            loadingMask = (<div className="loading-mask"><i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"/></div>);
        }

        let popup = null;
        if(this.state.message.body){
            popup = (
                <CustomAlert {...this.state.message}/>
            );
        }

        let title = null;
        if(this.props.module.settings.module_title){
            title = (
                <div className={'title'}>{this.props.module.settings.module_title}</div>
            );
        }

        let header = null;
        if(this.state.fundraisingCampaignsCount || this.state.incrementalCampaignsCount){
            header = (
                <div className="header">
                    {this.state.fundraisingCampaignsCount > 0 &&
                        <span dangerouslySetInnerHTML={{__html: __d('advocacy','You\'ve raised %s from %s donors in support.', `<b>$${this.state.totalRaised.toLocaleString(undefined, {minimumFractionDigits: 2})}</b>`, `<b>${this.state.totalDonors}</b>`)}}/>
                    }
                    {this.state.incrementalCampaignsCount > 0 &&
                        <span dangerouslySetInnerHTML={{__html: __d('advocacy','You have %s active participants.', `<b>${this.state.totalParticipants}</b>`)}}/>
                    }
                    <span className={'link'} onClick={this.getDetails.bind(this, 'category', this.props.module.settings.categories)}>{__d('advocacy','View details')}</span>
                </div>
            );
        }

        let detailsMask = null;
        let details = null;
        if(this.state.showDetails){
            detailsMask = (
                <div className="details-popup-mask"/>
            );
            details = (
                <div className="details-popup">
                    <div className="title">{__d('advocacy','Donors/Participants')}</div>
                    <div className="content">
                        {_.map(this.state.details, (data, campaignId) => {
                            return (
                                <React.Fragment key={`group-${campaignId}`}>
                                    <div className="title">
                                        <span>{data.campaign.name}</span>
                                        <a href={data.campaign.url}>{__d('advocacy','View Campaign')}</a>
                                    </div>
                                    <div className={`records ${!data.category.incremental ? 'has-amount': ''}`}>
                                        <div className="record header">
                                            <div className="name">{__d('advocacy','Full Name')}</div>
                                            {!data.category.incremental && <div className="amount">{__d('advocacy','Amount')}</div>}
                                            <div className="date">{__d('advocacy','Date')}</div>
                                        </div>
                                        {_.map(data.items, item => {
                                            return (
                                                <div className="record" key={`item-${item.goal.id}`}>
                                                    <div className="name">{item.goal.private ? __d('advocacy','Anonymous') : item.person.fullname}</div>
                                                    {!data.category.incremental &&
                                                        <div className="amount">
                                                            ${item.goal.amount.toLocaleString(undefined, {minimumFractionDigits: 2})}
                                                        </div>
                                                    }
                                                    <div className="date">{moment(item.goal.created, 'YYYY-MM-DD hh:mm:ss').format('MMM Do, YYYY')}</div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </React.Fragment>
                            );
                        })}
                    </div>
                    <div className="actions">
                        <button onClick={this.closeDetails.bind(this)}>{__d('advocacy','Close')}</button>
                    </div>
                </div>
            );
        }

        return (
            <div className="content">
                {loadingMask}
                {popup}
                {detailsMask}
                {details}
                {title}
                {header}
                <div className="campaigns">
                    {this.props.campaigns.map(campaign => {
                        let imagePath = SS.com.FileManager.frontend.util.Resizer.getResizedPath(campaign.AdvocacyCampaign.image_path, this.props.module.settings.thumbnail_size, this.props.module.settings.thumbnail_size, null, true);
                        return (
                            <div className="campaign" key={`campaign-${campaign.AdvocacyCampaign.id}`}>
                                <div className="campaign-thumbnail">
                                    <a href={campaign.AdvocacyCampaign.url}>
                                        <img src={imagePath} width={this.props.module.settings.thumbnail_size} height={this.props.module.settings.thumbnail_size} />
                                    </a>
                                </div>
                                <div className="campaign-details">
                                    <div className="name">
                                        <a href={campaign.AdvocacyCampaign.url} dangerouslySetInnerHTML={{__html: campaign.AdvocacyCampaign.name}}/>
                                    </div>
                                    <div className="details">
                                        {campaign.AdvocacyCategory.incremental === false &&
                                            <span>{__d('advocacy','%s from %s donors', campaign.AdvocacyCampaign.raised.toLocaleString(undefined, {minimumFractionDigits: 2}), campaign.AdvocacyCampaign.participants)}</span>
                                        }
                                        {campaign.AdvocacyCategory.incremental === true &&
                                            <span>{__d('advocacy','%s participants', campaign.AdvocacyCampaign.participants)}</span>
                                        }
                                        {campaign.AdvocacyCampaign.participants > 0 &&
                                            <span className={'link'} onClick={this.getDetails.bind(this, 'campaign', campaign.AdvocacyCampaign.id)}>{__d('advocacy','View Details')}</span>
                                        }
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    {_.size(this.props.campaigns) === 0 &&
                        <div className="no-campaigns">{__d('advocacy','No campaigns available')}</div>
                    }
                </div>
            </div>
        );
    }
}

CategorySummary.defaultProps = {
    module: {},
    campaigns: [],
    campaignBaseUrl: null,
};
CategorySummary.displayName = 'CategorySummary';
